import React from 'react'

export default function Footer({children}) {
  return (
    <div>{children}</div>
  )
}
